import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div>
        <h4>QMX Technology</h4>
        <p style={{ fontSize: '0.9rem', lineHeight: 1.6, margin: 0 }}>
          Scalable communication infrastructure and software solutions for modern business.
        </p>
      </div>
      <div>
        <h4>Services</h4>
        <Link to="/communication">Communication</Link>
        <Link to="/ai-application">AI Application</Link>
        <Link to="/bespoke-software">Bespoke Software</Link>
        <Link to="/research-security">Research & Security</Link>
      </div>
      <div>
        <h4>Contact</h4>
        <a href="tel:0832341263">Phone (WhatsApp): 083 234 1263</a>
        <a href="mailto:technical@qmxtechnology.com">technical@qmxtechnology.com</a>
      </div>
      <div>
        <h4>Legal</h4>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/api-docs">API Docs</Link>
      </div>
    </div>
    <div className="footer-bottom">
      &copy; {new Date().getFullYear()} QMX Technology —{' '}
      <a href="https://qmxtechnology.com">qmxtechnology.com</a>
    </div>
  </footer>
);

export default Footer;
